/*
 * This is the Top Level Search Page
 * 
 * <Search />
 *      <MySelect />
 *      <SearchByName />
 *          <SearchByNameDisplay />
 */

import React, { useState }                      from 'react'
import { allGradsAction }                       from '../Redux/Actions'
import axios                                    from 'axios'
import {
   Button,
   Dialog,
   DialogContent,
   Grid
}                                               from '@material-ui/core'
import ClassLetterUpdateCheck                   from '../Components/ClassLetterUpdateCheck.js'
import { CLIENT_PUBLIC_TOKEN }                  from '../config.js'
import { Link }                                 from 'react-router-dom'
import { node_server }                          from '../Helpers/index.js'
import PropTypes                                from 'prop-types'
import SnackBar                                 from '../Atoms/SnackBar.js'
import { store }                                from '../Redux/Store'
import Typography                               from '@material-ui/core/Typography'
import { userIdOfBioToShowAction }              from '../Redux/Actions'

const SearchByNameDisplay = ({ alumniArray, alumniHasBio, searchForAllAlumni }) => {

   const { userType }                                                =  store.getState()

   const [ display,                             setDisplay                ]  =  useState({})
   const [ showClassLetterUpdateCheck,          setShowClassLetterUpdateCheck ]  =  useState(false)
   const [ snackBarMsg,                         setSnackBarMsg    ]  =  useState('')
   const [ snackBarOpen,                        setSnackBarOpen   ]  =  useState(false)
   const [ snackBarType,                        setSnackBarType   ]  =  useState('')
   const [ tpsClass,                            setTpsClass       ]  =  useState('')
   const [ usersNew,                            setUsersNew       ]  =  useState([])
   const [ usersOriginal,                       setUsersOriginal  ]  =  useState([])

   const handleClick = (e) => {
      store.dispatch( allGradsAction([{userId: e}]) )
      if( e > 9 ){
         store.dispatch( userIdOfBioToShowAction( e ) )
      }
   }

   const handleCloseModal = () => {
      setShowClassLetterUpdateCheck(false)
   }

   const handleFixClassLetter = (tpsClass) => {
      axios.defaults.headers.common = {Accept: "application/json, text/plain, */*", 'Authorization': `Bearer ${CLIENT_PUBLIC_TOKEN}`}
      axios.put(node_server + `admin/tpsClassToLowerCase/tbl_auth/${tpsClass}`)
         .then( res => {
            setDisplay(
               res.data.usersOriginal.map( ( u, i ) => {
               return(
                  <Grid container key={u.userId} >
                     <Grid item xs={5} >
                        <Typography align='left' >
                           { u.username }
                        </Typography>
                     </Grid>
                     <Grid item xs={5} >
                        <Typography align='left' style={{marginLeft: '5rem'}} >
                           { res.data.usersNew[i].username }
                        </Typography>
                     </Grid>
                  </Grid>
               )
      } )
            )
            setUsersNew(res.data.usersNew)
            setUsersOriginal(res.data.usersOriginal)
            setShowClassLetterUpdateCheck(true)
         } )
         .catch( error => {
            console.error(error)
         } )
   }

   const alumniToDisplay = alumniArray.map( (alum, i) => {
      /* Get TPS Class to show Fix Class Letter button if the class letter is still upper case */
      const tpsClassArray = alum.username.split('.')
      let tpsClass
      if (tpsClassArray.length === 3) {
         tpsClass = tpsClassArray[2]
      }
      else {
         setSnackBarMsg('There is a TPS Class member whose username in SearchByNameDisplay is not properly formed.')
         setSnackBarType('error')
         setSnackBarOpen(true)
         setTimeout(() => {
            setSnackBarOpen(false)
            setSnackBarMsg('')
            setSnackBarType('')
         }, 2500);
      }

      /* Returns and prints username w/o additional info button is NOT active */
      if( searchForAllAlumni && !alum.isActive ){
         return(<Grid container key={i} style={{marginTop: '0.25rem'}}>
                     <Grid item xs={12} sm={5} >
                           <Typography  id={alum.userId} variant='h6' align='left' style={{marginLeft: '4rem'}} >
                              { alum.username }
                           </Typography>
                     </Grid>
                     {userType === 'superUser' && tpsClassArray.length === 3 && /[A-Z]/.test(tpsClass)
                        ?
                           <Grid item xs={6} sm={3} >
                              <Button variant='outlined' color='primary'>
                                 <Typography  variant='body2' onClick={() => handleFixClassLetter(tpsClass)} >
                                    Fix Class Letter
                                 </Typography>
                              </Button>
                           </Grid>
                        :
                           <Grid item xs={6} sm={3} >
                              <Button variant='outlined' color='primary' disabled >
                                 <Typography  variant='body2' >
                                    Fix Class Letter
                                 </Typography>
                              </Button>
                           </Grid>
                     }
                  </Grid>)
      }
      /* Returns and prints username WITH additional info button if they exist */
      else{
         return(<Grid container key={i} style={{marginTop: '0.25rem'}}>
                     <Grid item xs={12} sm={5} >
                           <Typography  variant='h6' align='left' style={{marginLeft: '4rem'}} >
                              { alum.username }
                           </Typography>
                     </Grid>
                     {userType === 'superUser' && tpsClassArray.length === 3 && /[A-Z]/.test(tpsClass)
                        ?
                           <Grid item xs={6} sm={3} >
                              <Button variant='outlined' color='primary'>
                                 <Typography  variant='body2' onClick={() => handleFixClassLetter(tpsClass)} >
                                    Fix Class Letter
                                 </Typography>
                              </Button>
                           </Grid>
                        :
                           <Grid item xs={6} sm={3} >
                              <Button variant='outlined' color='primary' disabled >
                                 <Typography  variant='body2' >
                                    Fix Class Letter
                                 </Typography>
                              </Button>
                           </Grid>
                     }
                     <Grid item xs={3} sm={2} >
                           <Link to="/GetGradsByUserId" id={alum.userId} onClick={() => handleClick(alum.userId)} style={{textDecoration: 'none'}} >
                              <Button variant='outlined' color='primary'>
                                 <Typography  variant='body2' >
                                       Contact Info
                                 </Typography>
                              </Button>
                           </Link>
                     </Grid>
                     <Grid item xs={3} sm={1} >
                           { alumniHasBio.includes(alum.userId) ?
                              <Button variant='outlined' color='secondary'>
                                 <Link to="/ShowOneBioPage" id={alum.userId} onClick={() => handleClick(alum.userId)} style={{textDecoration: 'none'}} >
                                       <Typography  variant='body2' >
                                          Bio
                                       </Typography>
                                 </Link>
                              </Button>
                              : null
                           }
                     </Grid>
                  </Grid>)
      }
   } )

   return (
      <div style={{marginTop: '4rem'}} >
         <Grid>
            {snackBarOpen
               ?
                  <Grid style={{marginTop: '1rem'}} >
                     <SnackBar msg={snackBarMsg} type={snackBarType} />
                  </Grid>
               :
                  null
            }
         </Grid>
         <Grid container item xs={12} sm={6} justifyContent='flex-start' style={{marginTop: '15rem'}} >
            { showClassLetterUpdateCheck
               ?
                  <Dialog
                     open={true}
                  >
                     <DialogContent>
                        <ClassLetterUpdateCheck display={display} handleCloseModal={handleCloseModal} />
                     </DialogContent>
                  </Dialog>
               :
                  null
            }
         </Grid>
         { alumniToDisplay }
      </div>
   )
}

SearchByNameDisplay.propTypes = {
    alumniArray: PropTypes.array,
    alumniHasBio: PropTypes.array,
    searchForAllAlumni: PropTypes.bool
}

export default SearchByNameDisplay
